// Pre-fills timestamps as a *starting scaffold* the user refines by re-tagging.
//
// Two curves:
//  'even'  — moves spread uniformly over the video.
//  'paced' — follows the think-time pattern seen in large game-corpus analyses
//            (lichess/DGT data): opening moves are played quickly (theory/prep),
//            per-move think time peaks in the early middlegame around ~40% of
//            the game, then tapers as positions simplify and clocks run down.
//
// The gap BEFORE move i is proportional to the think time spent ON move i, so
// small opening weights put early moves close together near the video start.

// Relative think-time weight at normalized game progress x ∈ [0, 1].
// Baseline keeps every move non-instant; the hump peaks at x = 1.3/(1.3+1.9) ≈ 0.41
// with roughly 3.5× the opening rate.
export function paceWeight(x) {
  return 0.15 + 3.5 * Math.pow(x, 1.3) * Math.pow(1 - x, 1.9)
}

export function distributeStamps({ count, duration, curve = 'even' }) {
  if (!Number.isInteger(count) || count <= 0) return []
  if (!Number.isFinite(duration) || duration <= 0) return []

  const gaps = []
  for (let i = 0; i < count; i++) {
    if (curve === 'paced') {
      const x = count === 1 ? 0.5 : i / (count - 1)
      gaps.push(paceWeight(x))
    } else {
      gaps.push(1)
    }
  }

  const total = gaps.reduce((a, b) => a + b, 0)
  // Reserve an average-sized tail after the last move so it doesn't land on
  // the video's final frame.
  const scale = duration / (total + total / count)
  const stamps = []
  let cumulative = 0
  for (const gap of gaps) {
    cumulative += gap
    stamps.push(cumulative * scale)
  }
  return stamps
}
